export default __webpack_public_path__ + "static/media/ic_equatorial_guinea.8041690a.svg";